import { Component ,OnInit} from '@angular/core';
import { Constant } from 'src/app/constants/Constant';

@Component({
  selector: 'app-searchforstudents',
  templateUrl: './searchforstudents.component.html',
  styleUrls: ['./searchforstudents.component.scss']
})
export class SearchforstudentsComponent implements OnInit{
  selectedTab: string = 'tab1';
  schoolYear: string = "";
  currSchoolYear: string = "";
  prevSchoolYear: string = "";
  nextSchoolYear: string = "";
  issearchKeyword: boolean = false;
  todaysDate: Date = new Date();

  ngOnInit() {
    //console.log(policyYear);
    const policyYear = Constant.PolicyYear;
    this.currSchoolYear = policyYear.toString();
    this.prevSchoolYear = (policyYear - 1).toString();
    this.nextSchoolYear = (policyYear + 1).toString();
    this.schoolYear = this.currSchoolYear;    
  }


  toggleTab(e:any){
    
    if(e.target.dataset.bsTarget == '#student-search'){
      this.issearchKeyword=true;
    }
    else{
      this.issearchKeyword=false;
    }
  
  }
}
